const B=a=>{const r=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${r}/products/${a.handle}`},S=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),A=(a,r)=>{const i=r.getTemplateOptions("product"),b=i.productPageUrl(a),w=r.getPrice?r.getPrice(a):a.price,C=r.getCompareAtPrice?r.getCompareAtPrice(a):a.compare_at_price,y=r.isProductOnSale(C,w),g=a.images,$=g?g.length:0,M=a.featured_image||(g&&g.length>0?g[0]:null);let f="default";$>1&&(f=i.forceHoverGallery?"hover":"gallery");const x=()=>{var _,s,d;let u="";if(y&&(u+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(d=(s=(_=a.metafields)==null?void 0:_.card)==null?void 0:s.badges)!=null&&d.value)for(const c of a.metafields.card.badges.value)u+=`<div class="product-card__badge badge body-extra-small">${c.name}</div>`;return u?`<div class="product-card__badges">${u}</div>`:""},v=()=>{var _,s,d;let u="";if(a.options_with_values){for(const c of a.options_with_values)if(c.name==="Size"){let l="";for(const e of c.values){const t=a.variants.find(o=>o.option1===e||o.option2===e||o.option3===e),p=t?t.available:!1;l+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${S(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(t==null?void 0:t.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${p?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${S(e)}"
                  ${p?"":"disabled"}
                  class="quick-add-form__variant-label${p?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                </label>
              </div>
            `}u+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${l}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(c.name==="Colour"||c.name==="Color"){let l="";for(let e=0;e<Math.min(c.values.length,3);e++){const t=c.values[e],p=a.variants.find(h=>h.option2===t),o=(s=(_=t.swatch)==null?void 0:_.color)==null?void 0:s.rgba,n=(d=t.swatch)==null?void 0:d.image;l+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${S(t)}"
                  name="Color"
                  value="${t}"
                  data-variant-id="${(p==null?void 0:p.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${t.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${S(t)}"
                  class="quick-add-form__variant-label--swatch${n?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${t.product_url||""}"
                  data-swatch
                  data-color="${S(t)}"
                  ${o||n?`style="${o?`background-color: rgba(${o}); --swatch-color: rgba(${o});`:""}${n?`background-image: url(${n});`:""}"`:`style="--swatch-color: var(--swatch-color-${S(t)});"`}
                >
                  <span class="visually-hidden">${t}</span>
                </label>
              `}c.values.length>3&&(l+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${c.values.length-3}</span>
                </div>
              `),u+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${l}
              </div>
            `}}return u},m=()=>y?`
        <span class="product-card__price--sale">${r.formatCurrency(w)}</span>
        <s class="product-card__price--compare">${r.formatCurrency(C)}</s>
      `:`<span class="product-card__price--regular">${r.formatCurrency(w)}</span>`,k=()=>{if(f==="gallery"&&$>1){let u="";for(let _=0;_<Math.min($,3);_++){const s=g[_];u+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${s.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${u}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(f==="hover"&&$>1){let u="";for(let _=0;_<Math.min($,2);_++){const s=g[_];u+=`<img src="${s.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${u}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${b}">
          ${M?`<img src="${M.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${i.forceHoverGallery&&$>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${x()}
        ${k()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${m()}
          </div>
          <div class="product-card__quick-add-form">
            ${v()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},P=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),T=(a,r)=>{const i=r.getTemplateOptions("product"),b=i.productPageUrl(a),w=r.getPrice?r.getPrice(a):a.price,C=r.getCompareAtPrice?r.getCompareAtPrice(a):a.compare_at_price,y=a.images,g=y?y.length:0,$=3,M=g<$?g:$;let f="gallery";g<=1&&(f="default"),g===0&&(f="empty"),i.forceHoverGallery&&(f="hover");let x=0,v=!1;if(a.options_with_values)for(const d of a.options_with_values){const c=d.name.toLowerCase();if(c==="colour"||c==="color"){x=d.values.length,v=x>1;break}}const m=()=>{var c,l,e;let d="";if(a.options_with_values){for(const t of a.options_with_values)if(t.name==="Size"){let p="";for(const o of t.values){const n=a.variants.find(q=>q.option1===o||q.option2===o||q.option3===o),h=n?n.available:!1;p+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${P(o)}"
                  name="Size"
                  value="${o}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${h?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${P(o)}"
                  ${h?"":"disabled"}
                  class="quick-add-form__variant-label${h?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${o}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${p}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(t.name==="Colour"||t.name==="Color"){let p="";for(let o=0;o<Math.min(t.values.length,3);o++){const n=t.values[o],h=a.variants.find(H=>H.option2===n),q=(l=(c=n.swatch)==null?void 0:c.color)==null?void 0:l.rgba,L=(e=n.swatch)==null?void 0:e.image;p+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${P(n)}"
                  name="Color"
                  value="${n}"
                  data-variant-id="${(h==null?void 0:h.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${n.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${P(n)}"
                  class="quick-add-form__variant-label--swatch${L?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${n.product_url||""}"
                  data-swatch
                  data-color="${P(n)}"
                  ${q||L?`style="${q?`background-color: rgba(${q}); --swatch-color: rgba(${q});`:""}${L?`background-image: url(${L});`:""}"`:`style="--swatch-color: var(--swatch-color-${P(n)});"`}
                >
                  <span class="visually-hidden">${n}</span>
                </label>
              `}t.values.length>3&&(p+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${t.values.length-3}</span>
                </div>
              `),d+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${p}
              </div>
            `}}return d},k=()=>{var c,l,e;let d="";if((e=(l=(c=a.metafields)==null?void 0:c.card)==null?void 0:l.badges)!=null&&e.value)for(const t of a.metafields.card.badges.value)d+=`<div class="product-card__badge badge body-extra-small">${t.name}</div>`;return d?`<div class="product-card__badges">${d}</div>`:""},u=()=>C>w?`
        <span class="product-card__price--sale">${r.formatCurrency(w)}</span>
        <s class="product-card__price--compare">${r.formatCurrency(C)}</s>
      `:`<span class="product-card__price--regular">${r.formatCurrency(w)}</span>`,_=()=>{if(f==="gallery"&&g>1){let d="";for(let c=0;c<Math.min(g,$);c++){const l=y[c];d+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${l.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${M}</span>
          </div>
        </div>
      `}else if(f==="hover"&&g>1){let d="";for(let c=0;c<Math.min(g,2);c++){const l=y[c];d+=`<img src="${l.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else if(f==="default"){const d=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},s=()=>{var l,e,t;const d=(t=(e=(l=a.metafields)==null?void 0:l.card)==null?void 0:e.badges)!=null&&t.value?`
      <div class="product-card__badges--mobile">
        ${k()}
      </div>
    `:"",c=v?`
      <div class="product-card__color-count">
        <span class="body">${x} colours</span>
      </div>
    `:"";return`
      <div class="product-card__meta">
        ${d}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${m()}
        </div>
        ${c}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${k()}
        ${_()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||b}"
        >
          <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      ${s()}
    </product-card>
  `},z=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),O=(a,r)=>{const i=r.getTemplateOptions("product"),b=i.productPageUrl(a),w=r.getPrice?r.getPrice(a):a.price,C=r.getCompareAtPrice?r.getCompareAtPrice(a):a.compare_at_price,y=C>w,g=a.images,$=g?g.length:0,M=3;let f="hover";$<=1&&(f="default"),i.forceGallery&&(f="gallery");const x=()=>{var d,c,l;let s="";if(a.options_with_values){for(const e of a.options_with_values)if(e.name==="Size"){let t="";for(const p of e.values){const o=a.variants.find(h=>h.option1===p||h.option2===p||h.option3===p),n=o?o.available:!1;t+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-option-${z(p)}"
                  name="Size"
                  value="${p}"
                  data-variant-id="${(o==null?void 0:o.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${n?"":"disabled"}
                >
                <label
                  for="${i.context||"card"}-${a.id}-option-${z(p)}"
                  ${n?"":"disabled"}
                  class="quick-add-form__variant-label${n?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${p}</span>
                </label>
              </div>
            `}s+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${i.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${t}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(e.name==="Colour"||e.name==="Color"){let t="";for(let p=0;p<Math.min(e.values.length,3);p++){const o=e.values[p],n=a.variants.find(L=>L.option2===o),h=(c=(d=o.swatch)==null?void 0:d.color)==null?void 0:c.rgba,q=(l=o.swatch)==null?void 0:l.image;t+=`
                <input
                  type="radio"
                  id="${i.context||"card"}-${a.id}-color-${z(o)}"
                  name="Color"
                  value="${o}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${o.selected?"checked":""}
                >
                <label
                  for="${i.context||"card"}-${a.id}-color-${z(o)}"
                  class="quick-add-form__variant-label--swatch${q?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${o.product_url||""}"
                  data-swatch
                  data-color="${z(o)}"
                  ${h||q?`style="${h?`background-color: rgba(${h}); --swatch-color: rgba(${h});`:""}${q?`background-image: url(${q});`:""}"`:`style="--swatch-color: var(--swatch-color-${z(o)});"`}
                >
                  <span class="visually-hidden">${o}</span>
                </label>
              `}e.values.length>3&&(t+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${e.values.length-3}</span>
                </div>
              `),s+=`
              <div class="quick-add-form__color-swatches">
                ${i.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${t}
              </div>
            `}}return s},v=()=>{const s=a.tags||[],d=s.some(e=>e.includes("badge:"));if(!(y||d))return"";let l="";if(y)l=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round((C-w)*100/C)}%</span>
        </div>
      `;else{let e=!1;if(!e){for(const t of s)if(t.includes("badge:use-code-")){l=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${t.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}if(!e&&s.includes("badge:trending")&&(l='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',e=!0),!e&&s.includes("badge:low-in-stock")&&(l='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',e=!0),!e){for(const t of s)if(t.includes("badge:custom-")){l=`<div class="product-card__badge badge product-card__badge--custom">${t.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}!e&&s.includes("badge:coming-soon")&&(l='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',e=!0),!e&&s.includes("badge:sold-out")&&(l='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',e=!0),!e&&s.includes("badge:pre-order")&&(l='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',e=!0),!e&&s.includes("badge:most-loved")&&(l='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',e=!0),!e&&s.includes("badge:best-seller")&&(l='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',e=!0),!e&&s.includes("badge:new")&&(l='<div class="product-card__badge badge product-card__badge--new">New</div>',e=!0)}return l?`<div class="product-card__badges">${l}</div>`:""},m=()=>`
      <div class="product-card__price-wrapper">
        ${y?`<s class="product-card__price--compare">${r.formatCurrency(C)}</s>`:""}
        <span class="product-card__price--${y?"sale":"regular"}">${r.formatCurrency(w)}</span>
      </div>
    `,k=()=>{if(f==="gallery"&&$>1){let s="";for(let d=0;d<Math.min($,M);d++){const c=g[d];s+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${c.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${s}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(f==="hover"&&$>1){let s="";for(let d=0;d<Math.min($,2);d++){const c=g[d];s+=`<img src="${c.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${s}
        </a>
      `}else{const s=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${s?`<img src="${s.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},u=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,_=()=>{const s=`
      <div class="product-card__badges-mobile">
        ${v()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${m()}
        </div>
        ${s}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${v()}
        ${u()}
        ${k()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${x()}
        </div>
      </div>
      ${_()}
    </product-card>
  `},I=(a,r)=>{var w;const i=((w=window.theme)==null?void 0:w.brandEnvironment)||"cdp";switch(i==="gia"?"iamgia":i){case"iamgia":return T(a,r);case"tigermist":return O(a,r);case"cdp":default:return A(a,r)}},U=(a,r)=>{var g,$,M,f,x;const i=((g=r==null?void 0:r.dataset)==null?void 0:g.sectionId)||"no-results",b=($=r==null?void 0:r.dataset)==null?void 0:$.title,w=(M=r==null?void 0:r.dataset)==null?void 0:M.headingSize,C=(f=r==null?void 0:r.dataset)==null?void 0:f.buttonLabel,y=(x=r==null?void 0:r.dataset)==null?void 0:x.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(v,m)=>{const k=m.props,_=k.helpers.getProducts();if(k.loading===!1)return _.length===0?null:v`
            <${m.templates.title} />
            <${m.templates.productList} />
            <${m.templates.button} />
          `}},title:{render:v=>b?v`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${w}">${b}</h2>
            </div>
          `:v``},productList:{render:(v,m)=>v`
        <slider-component class="slider-component-full-width">
          <${m.templates.products} />
        </slider-component>
      `},products:{render:(v,m)=>{const u=m.props.helpers.getProducts();return v`<ul
          id="Slider-${i}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${u.map((_,s)=>v`<li class="results-grid__tile">
                <${m.templates.product} key=${s} product=${_} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(v){return B(v)}},render:(v,m)=>{const k=m.props,u=k.product,_=k.helpers;return v`<div
          class="tagalys-section__slide"
          id="Slide-${u.id}"
          dangerouslySetInnerHTML=${{__html:I(u,_)}}
        />`}},carouselActions:{render:v=>{var m,k,u,_,s,d;return v`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(u=(k=(m=window.theme)==null?void 0:m.strings)==null?void 0:k.accessibility)==null?void 0:u.previousSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(d=(s=(_=window.theme)==null?void 0:_.strings)==null?void 0:s.accessibility)==null?void 0:d.nextSlide}"
            aria-controls="Slider-${i}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:v=>C&&y?v`
            <div class="product-recommendations__button">
              <a href="${y}" class="button button--secondary">${C}</a>
            </div>
          `:v``}}};export{B as c,I as r,U as t};
